// The words a visitor reads for each start step (owner's pick 2026-10-25, the demo loader canvas, B). main.js names its
// steps plainly: those names go into the start record (rescue.js) and the error reports' step tags (boot.js), so they
// stay. The loading screens show these warmer ones: the map's own (loader.js) and the website's cover over it
// (apps/site viewer-embed.js), both from the 'map-progress' event's `words`, in the loader's language (English or
// Finnish, loader.js data-lang). A step not listed shows its own name.
const WORDS = {
  'Downloading the map': ['Fetching the map…', 'Haetaan karttaa…'],
  'Reading the survey': ['Reading the survey…', 'Luetaan maastotietoja…'], // (config.js loadResort)
  'Shaping the terrain': ['Shaping the land…', 'Muotoillaan maastoa…'],
  'Raising the buildings': ['Raising the buildings…', 'Pystytetään rakennuksia…'],
  'Adding the details': ['Adding the little details…', 'Lisätään pieniä yksityiskohtia…'],
  'Growing the forest': ['Growing the forest…', 'Kasvatetaan metsää…'],
  'Preparing the drawing': ['Getting the view ready…', 'Valmistellaan näkymää…'],
  'Growing the trees': ['Planting the trees…', 'Istutetaan puita…'],
  'Bringing the map to life': ['Bringing it to life…', 'Herätetään kartta eloon…'],
  'The animals are taking longer, they join when ready': ['The animals will join in a moment', 'Eläimet tulevat mukaan hetken päästä'],
  'Preparing the night sky': ['Lighting up the night sky…', 'Sytytetään yötaivas…'],
  'Final check': ['Almost there…', 'Melkein valmista…'],
  Ready: ['Here it is', 'Tässä se on'],
};

/**
 * @param {string} step main.js's name of the step
 * @param {string} [lang] 'fi' for Finnish, else English
 */
export const stepWords = (step, lang) => WORDS[step]?.[lang === 'fi' ? 1 : 0] ?? step;
/** Every step's words in one language: the loader's words box is as wide as the widest (loader.js, 2026-11-05). @param {string} [lang] */
export const allStepWords = (lang) => Object.values(WORDS).map((w) => w[lang === 'fi' ? 1 : 0]);
